import React, { useEffect, useState } from 'react'
import StarIcon from '@mui/icons-material/Star'
import { geocodeByLatLng } from 'react-google-places-autocomplete'
import moment from 'moment'
import { saveOrUpdateDataById, updateDataById } from '../../apis/generalApis'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import { ScaleLoader } from 'react-spinners'
import UserImagePlaceholder from '../../assets/imgs/user-image-placeholder.png'
import { Avatar } from '@mui/material';

const ServicesCard = ({
  isNewBooking = false,
  booking = {},
  handleConfirmReservationModal,
  getRequestedBookings,
  handleJobDetailsModal,
  setSelectedBooking,
  getScheduledBookings,
  getClientPastBookings,
  getStylistScheduledBookings,
  component,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (isNewBooking && user?.user_type === 'provider') {
      booking.stylist = booking?.client
    }
    if (user?.user_type === 'provider' && !isNewBooking) {
      booking.stylist = booking?.user
    }
  }, [])

  const getAddressByLating = async (booking) => {
    let address = await geocodeByLatLng({
      lat: booking?.latitude ?? 48.8584,
      lng: booking?.longitude ?? 2.2945,
    }).then((val) => {
      // console.log({ val })
    })
    return ''
  }

  const handleBookReservation = async () => {
    if (booking?.status === 'in_review') {
      setIsLoading(true)
      let response = await saveOrUpdateDataById('accept-booking-request', {
        user_id: booking?.user?.id,
        booking_id: booking?.id,
      })
      setIsLoading(false)
      if (response.success === true) {
        getRequestedBookings()
        Swal.fire({
          title: 'Booking Confirmed!',
          timer: 3000,
          icon: 'success',
          confirmButtonColor: '#2597F6',
        })
      }
      return
    }
    let body = {
      user_id: booking?.client?.id,
      stylist_id: user?.id,
      service_id: booking?.id,
      latitude: booking?.latitude,
      longitude: booking?.longitude,
      style_size: 'small',
      date: booking?.date,
      timeslot: booking?.time,
      price: booking?.price,
      address: booking?.address,
      travel_charges: booking?.travel_charges,
    }
    setIsLoading(true)
    const response = await saveOrUpdateDataById('make-booking', body)
    setIsLoading(false)
    if (response?.success === true) {
      Swal.fire({
        title: 'Booking Created!',
        timer: 3000,
        icon: 'success',
        confirmButtonColor: '#2597F6',
      })
      handleConfirmReservationModal(false)
    }
  }

  const handleChatClick = () => {
    navigate('/chat', { state: { booking } })
  }

  const handleCancelBooking = async () => {
    Swal.fire({
      title: 'Are you sure you want to cancel this booking?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes',
    }).then(async (res) => {
      if (res.isConfirmed === true) {
        setIsLoading(true)
        let response = await updateDataById('cancel-booking', {
          user_id: user?.id,
          booking_id: booking?.id,
        })
        setIsLoading(false)
        if (getRequestedBookings && response?.success === true) {
          getRequestedBookings()
        }
        if (getStylistScheduledBookings && response?.success === true) {
          getStylistScheduledBookings()
        }
        if (response?.success === true && component === 'profile') {
          getScheduledBookings()
        }
      }
    })
  }
  const formatProfileImageUrl = () => {
    if (!isNewBooking) {
      if (user?.user_type === 'provider') {
        return booking?.user?.profile_image
          ? booking?.user?.profile_image
          : UserImagePlaceholder
      } else if (user?.user_type !== 'provider') {
        return booking?.stylist?.profile_image
          ? booking?.stylist?.profile_image
          : UserImagePlaceholder
      }
    } else {
      if (user?.user_type === 'provider') {
        return booking?.client?.profile_image
          ? booking?.client?.profile_image
          : UserImagePlaceholder
      } else if (user?.user_type !== 'provider') {
        return booking?.stylist?.profile_image
          ? booking?.stylist?.profile_image
          : UserImagePlaceholder
      }
    }
  }

  const formatName = () => {
    if (!isNewBooking) {
      if (user?.user_type === 'provider') {
        const name =
          booking?.user?.first_name +
          ' ' +
          booking?.user?.last_name?.toUpperCase().slice(0, 1) +
          '.'
        return name ?? ''
      } else if (user?.user_type !== 'provider') {
        const name =
          booking?.stylist?.first_name +
          ' ' +
          booking?.stylist?.last_name?.toUpperCase().slice(0, 1) +
          '.'
        return name ?? ''
      }
    } else {
      if (user?.user_type === 'provider') {
        const name =
          booking?.client?.first_name +
          ' ' +
          booking?.client?.last_name?.toUpperCase().slice(0, 1) +
          '.'
        return name ?? ''
      } else if (user?.user_type !== 'provider') {
        const name =
          booking?.stylist?.first_name +
          ' ' +
          booking?.stylist?.last_name?.toUpperCase().slice(0, 1) +
          '.'
        return name ?? ''
      }
    }
  }

  const calculateRating = () => {
    if (!isNewBooking) {
      if (user?.user_type === 'provider') {
        return Number(booking?.user?.avg_rating)?.toFixed(2)
      } else if (user?.user_type !== 'provider') {
        return Number(booking?.stylist?.avg_rating)?.toFixed(2)
      }
    } else {
      if (user?.user_type === 'provider') {
        return Number(booking?.client?.avg_rating)?.toFixed(2)
      } else if (user?.user_type !== 'provider') {
        return Number(booking?.stylist?.avg_rating)?.toFixed(2)
      }
    }
  }

  return (
    <div className="services-card pointer">
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 9,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <div className="position-relative">
        <img
          src={booking?.service?.primary_image || booking?.primary_image}
          alt="Styles"
          width="100%"
          height={300}
          className="pointer"
          style={{ borderRadius: '20px', objectFit: 'cover' }}
          onClick={() => {
            if (component === 'profile') {
              navigate('/styles')
              return
            }
            if (booking?.status !== 'complete') {
              handleJobDetailsModal()
              setSelectedBooking(booking)
            }
          }}
        />
        <div className="scheduled-service">
          <div className="p-3">
            <div className="d-flex justify-content-xxl-between flex-lg-row justify-content-lg-between justify-content-sm-center align-items-center flex-wrap justify-content-evenly justify-content-md-between">
              <div className="d-flex align-items-center">
                {!isNewBooking && (
                  <Avatar src={formatProfileImageUrl()} sx={{height: 60, width: 60}} />
                  // <img
                  //   src={formatProfileImageUrl()}
                  //   alt=""
                  //   height={60}
                  //   width={60}
                  //   style={{ borderRadius: '50%', objectFit: 'cover' }}
                  // />
                )}
                {isNewBooking && (
                  // <img
                  //   src={formatProfileImageUrl()}
                  //   alt=""
                  //   height={60}
                  //   width={60}
                  //   style={{ borderRadius: '50%', objectFit: 'cover' }}
                  // />
                  <Avatar src={formatProfileImageUrl()} sx={{height: 60, width: 60}} />
                )}
                <div className="d-inline-block p-2">
                  <h3 className="text-black m-0 font-weight-bold fs-24 text-capitalize">
                    {formatName()}
                  </h3>
                  <p className="fs-18 d-flex align-items-center">
                    {calculateRating()}
                    <StarIcon style={{ height: '1.3rem', color: '#DBC47A' }} />
                  </p>
                </div>
              </div>
              {(booking?.status === 'pending' ||
                booking?.status === 'in-progress') && (
                // || (isNewBooking
                <div className="text-center mt-md-2 mt-lg-0">
                  <button
                    id="serviceBtn"
                    className="commonBtn serviceCardBtn text-capitalize"
                  >
                    {booking?.service?.subservice?.name}
                  </button>
                  <p
                    className="fs-24 font-weight-bold m-0 mt-1"
                    style={{ marginRight: '.5rem !important' }}
                  >
                    {'$' + booking?.price}
                  </p>
                </div>
                // )
              )}
              {(booking?.status == 'complete' ||
                booking?.status == 'cancel') && (
                <div className="text-center mt-md-2 mt-lg-0">
                  <p className="fs-15 text-decoration-underline color-primary font-weight-bold">
                    Final Cost
                  </p>
                  <p className="fs-5 mb-2 fw-bold">
                    $
                    {Number(booking?.price + booking?.travel_charges).toFixed(
                      2,
                    )}
                  </p>
                  {booking?.status && (
                    <button
                      className="job-status-btn"
                      style={
                        booking?.status === 'complete'
                          ? { backgroundColor: '#7ADC68' }
                          : { backgroundColor: '#D40000' }
                      }
                    >
                      {booking?.status === 'complete' ? 'complete' : 'rejected'}
                    </button>
                  )}
                </div>
              )}
            </div>
            <hr />
            <div className="d-flex justify-content-between desc text-center">
              <div className="text-center">
                <p className="title mb-1 text-left text-md-center text-sm-center">
                  {/* {showDistance === true ? 'Location & Distance' : 'Location'} */}
                  Location
                </p>
                <p className="mb-2">{booking?.address}</p>
              </div>
              <div className="text-center">
                <p className="title mb-1 text-right text-md-center text-sm-center">
                  Scheduled Date & Time
                </p>
                <p>
                  {new Date(booking?.date).toLocaleDateString('en-US', {
                    weekday: 'short',
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })}
                  <br />
                  {!isNewBooking && (
                    <span>
                      {moment(booking?.start_timeslot?.split('-')[0], [
                        'HH:mm',
                      ]).format('hh:mm a') +
                        ' - ' +
                        moment(booking?.start_timeslot?.split('-')[1], [
                          'HH:mm',
                        ]).format('hh:mm a')}
                    </span>
                  )}
                  {isNewBooking && (
                    <span>
                      {moment(booking?.timeslot?.split('-')[0], [
                        'HH:mm',
                      ]).format('hh:mm a') +
                        ' - ' +
                        moment(booking?.timeslot?.split('-')[1], [
                          'HH:mm',
                        ]).format('hh:mm a')}
                    </span>
                  )}
                </p>
              </div>
            </div>
            <hr />

            {(booking?.status !== 'complete' &&
              booking?.status !== 'cancel') && (
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="text-center">
                  <p className="fs-16 text-decoration-underline color-primary fw-bold">
                    Travel cost
                  </p>
                  <p className="fs-16">
                    $
                    {booking?.travel_charges
                      ? Number(booking?.travel_charges)?.toFixed(2)
                      : 0}
                  </p>
                </div>
                <div className="text-center">
                  <p className="fs-16 text-decoration-underline color-primary fw-bold">
                    Final cost
                  </p>
                  <p className="fs-16">
                    $
                    {(
                      Number(booking?.price) + Number(booking?.travel_charges)
                    )?.toFixed(2)}
                  </p>
                </div>
              </div>
            )}
            {(booking?.status === 'complete' ||
              booking?.status === 'cancel') && (
              <div className="desc text-center">
                <div className="text-center">
                  <p className="title mb-2">Appointment</p>
                </div>
                <div className="">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="m-0 fs-16 font-weight-bold">Start Time:</p>
                    <p className="m-0 fs-16">{`${moment(
                      booking?.booking_start?.split(' ')[0],
                    ).format('dddd, MMM DD')} - ${moment(
                      booking?.booking_start,
                    ).format('LT')}`}</p>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="m-0 fs-16 font-weight-bold">End Time:</p>
                    <p className="m-0 fs-16">{`${moment(
                      booking?.booking_end?.split(' ')[0],
                    ).format('dddd, MMM DD')} - ${moment(
                      booking?.booking_end,
                    ).format('LT')}`}</p>
                  </div>
                </div>
              </div>
            )}
            {(booking?.status !== 'complete' &&
              booking?.status !== 'cancel') && (
              <div className="d-flex align-items-center justify-content-between service-card-buttons-wrapper mt-3 flex-wrap gap-sm-2">
                {booking?.status === 'in_review' && (
                  <button
                    className="srevices-card-btn"
                    id="chat-button"
                    onClick={handleBookReservation}
                  >
                    Confirm
                  </button>
                )}
                {booking?.status !== 'in_review' && (
                  <button
                    className="srevices-card-btn"
                    id="chat-button"
                    onClick={handleChatClick}
                  >
                    {!isNewBooking && booking?.status === 'complete'
                      ? 'Share Review'
                      : 'Chat'}
                  </button>
                )}
                <button
                  className="srevices-card-btn"
                  id="cancel-button"
                  onClick={handleCancelBooking}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ServicesCard
